export const SCHEMA_CREATE = 'SCHEMA_CREATE';
export const SCHEMA_UPDATE_BY_KEY = 'SCHEMA_UPDATE_BY_KEY';
export const SCHEMA_GET_LIST = 'SCHEMA_GET_LIST';
export const SCHEMA_GET_LIST_BY_ID = 'SCHEMA_GET_LIST_BY_ID';
export const SCHEMA_GET_DATATYPES = 'SCHEMA_GET_DATATYPES';
export const SCHEMA_GET_LIST_WITHVERSION = 'SCHEMA_GET_LIST_WITHVERSION';
export const SCHEMA_TYPE_CHANGE = 'SCHEMA_TYPE_CHANGE';